module.exports = __webpack_public_path__ + "af5261b2e37647e06c8d70e61779c382.MP3";